export default {
  title: 'Date & Time',
  buttons: {
    done: 'Done',
  },
};
